// 问卷单个题目组件
<template>
  <div class="task-item">
    <div style="text-align: left">
      <div style="font-weight: 700; font-size: 14pt; padding-bottom: 10px; font-family: 宋体">
        {{ `第${index + 1}题: ${taskItemData.subjectTitle}【${taskItemData.subjectType}】` }}
      </div>
      <div>
        <div ref="itemHeadBbtnRef" v-if="showBtn">
          <el-checkbox-group v-model="checkboxGroup" @change="checkBoxChange" size="mini">
            <el-checkbox-button v-for="item in charts" :label="item.value" :key="item.value">{{
              item.label
            }}</el-checkbox-button>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <div style="padding-top: 20px">
      <Draggable chosen-class="chosen" force-fallback="true" animation="1000">
        <div v-for="item in checkboxGroup" :key="item">

        
      <!-- 饼状0 -->
      <PieChart
          style="padding-bottom: 20px"
          :color="color"
          :exportChartList="exportChartList"
          :taskItemData="taskItemData"
          :chartType="'0'"
          v-if="checkChart('0') && haveSurveyItems && item=='0'"
        ></PieChart>
      <!-- 环形1 -->
      <PieChart
          style="padding-bottom: 20px"
          :color="color"
          :exportChartList="exportChartList"
          :taskItemData="taskItemData"
          :chartType="'1'"
          v-if="checkChart('1') && haveSurveyItems && item=='1'"
        ></PieChart>
      <!-- 柱状2 -->
      <BarChart
          style="padding-bottom: 20px"
          :color="color"
          :exportChartList="exportChartList"
          :taskItemData="taskItemData"
          :chartType="'2'"
          v-if="checkChart('2') && haveSurveyItems  && item=='2'"
        ></BarChart>
      <!-- 条形3 -->
      <BarChart
          style="padding-bottom: 20px"
          :color="color"
          :exportChartList="exportChartList"
          :taskItemData="taskItemData"
          :chartType="'3'"
          v-if="checkChart('3') && haveSurveyItems && item=='3'"
        ></BarChart>
      <!-- 折线图4 -->
      <LineChart
          style="padding-bottom: 20px"
          :color="color"
          :exportChartList="exportChartList"
          :taskItemData="taskItemData"
          :chartType="'4'"
          v-if="checkChart('4') && haveSurveyItems && item=='4'"
        ></LineChart>
      <!-- 表格5 -->
      <TableChart
          style="padding-bottom: 20px"
          :taskItemData="taskItemData"
          :showBtn="showBtn"
          :chartType="'5'"
          v-if="checkChart('5') && item=='5'"
        ></TableChart>
      <!-- 文字汇总6 -->
      <TextChart
          style="padding-bottom: 20px"
          :taskItemData="taskItemData"
          :chartType="'6'"
          v-if="checkChart('6') && item=='6'"
        ></TextChart>
      </div>
      </Draggable>

      <!-- <Draggable chosen-class="chosen" force-fallback="true" animation="1000">
        <template v-for="item in checkboxGroup" >
          <component
            style="padding-bottom: 20px"
            :key="item"
            :color="color"
            :exportChartList="exportChartList"
            :taskItemData="taskItemData"
            :chartType="item"  
            :is="getComponentItem(item).componentName"
          ></component>
        </template>
      </Draggable> -->
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import LineChart from './charts/LineChart.vue';
import PieChart from './charts/PieChart.vue';
import BarChart from './charts/BarChart.vue';
import TableChart from './charts/TableChart.vue';
import TextChart from './charts/TextChart.vue';
import { $eventBus } from '../utils/eventBus';
import { type } from 'jquery';
export default {
  components: {
    LineChart,
    PieChart,
    BarChart,
    TableChart,
    Draggable: draggable,
    TextChart,
  },
  props: {
    taskItemData: {
      // 单个题目内容数据
      type: Object,
      default: {},
    },
    index: {
      type: Number,
    },
    checkboxGroupItem: {
      type: Array,
      default: () => [],
    },
    batchCheckboxGroup: {
      type: Array,
      default: () => [],
    },
    chartsOrder:{
      type: Array,
      default: () => [],
    }
  },
  watch: {
    checkboxGroupItem: { // 返回记录的按钮勾选状态
      deep: true,
      immediate: true,
      handler(val) {
        if (Array.isArray(val) && val.length) {
          this.checkboxGroup = val;
          this.sortList()
        }
      },
    },
    batchCheckboxGroup: { // 批量按钮
      deep: true,
      immediate: true,
      handler(val) {
        if (Array.isArray(val)) {
          this.checkboxGroup = val;
          this.sortList()
        }
      },
    },
    chartsOrder: { // 排序改变
      deep: true,
      immediate: true,
      handler(val) {
        this.sortList()
      },
    },
    // checkboxGroup:{//监听勾选的按钮，重新排序
    //   deep: true,
    //   immediate: true,
    //   handler(val) {
    //     if (Array.isArray(val) && val.length) {
    //       // this.checkboxGroup = val;
    //       console.log('监听到勾选的按钮变化');
          
    //       // this.sortList()
    //     }
    //   },
    // }
  },
  computed: {
    haveSurveyItems() {
      return this.taskItemData.surveyItems && this.taskItemData.surveyItems.length && Array.isArray(this.taskItemData.surveyItems);
    },
  },
  data() {
    return {
      showBtn: true,
      color: [
        '#3aa1ff',
        '#36cbcb',
        '#fac858',
        '#ee6666',
        '#73c0de',
        '#3ba282',
        '#fc8452',
        '#9a60b4',
        '#ea7ccc',
        '#87cefa',
        '#da70d6',
        '#32cd32',
        '#6495ed',
        '#ff69b4',
        '#ba55d3',
        '#cd5c5c',
        '#ffa500',
        '#40e0d0',
        '#1e90ff',
        '#ff6347',
        '#7b68ee',
        '#00fa9a',
        '#ffd700',
        '#6b8e23',
        '#ff00ff',
        '#3cb371',
        '#b8860b',
        '#30e0e0',
      ],
      exportChartList: {}, // 导出的chart图
      subjectType: {
        1: '单选题',
        2: '多选题',
      },
      charts: [
        {
          value: '0',
          label: '饼状',
          componentName: 'PieChart',
        },
        {
          value: '1',
          label: '圆环',
          componentName: 'PieChart',
        },
        {
          value: '2',
          label: '柱状',
          componentName: 'BarChart',
        },
        {
          value: '3',
          label: '条形',
          componentName: 'BarChart',
        },
        {
          value: '4',
          label: '折线',
          componentName: 'LineChart',
        },
        {
          value: '5',
          label: '表格',
          componentName: 'TableChart',
        },
        {
          value: '6',
          label: '文字汇总',
          componentName: 'TextChart',
        },
      ],
      checkboxGroup: ['5','0'],
    };
  },
  created() {
    // $eventBus.$on('batchSetCheckGroup', ({batchCheckboxGroup}) => {
    //   if (batchCheckboxGroup.length) {
    //     this.checkboxGroup = batchCheckboxGroup
    //   }
    // });
  },
  methods: {
    sortList(){
      let sortedArr = this.checkboxGroup.map(item => {
        let chartItem = this.chartsOrder.find(chart => chart.value === item);
        return { value: item, orderNo: chartItem.orderNo };
      }).sort((a, b) => a.orderNo - b.orderNo).map(item => item.value);
      this.checkboxGroup=sortedArr;
    },
    checkChart(chartId) {
      return this.checkboxGroup.find((item) => item === chartId);
    },
    getComponentItem(value) {
      return this.charts.find(item=>item.value === value)
    },
    checkBoxChange(val) {
      if (val.length) {
        let last = val.pop()
        val.unshift(last)
        this.checkboxGroup = val;
        this.sortList()
      } else {
        this.checkboxGroup = []
      }
    },
  },
};
</script>

<style lang="less" scoped>
.task-item {
  // padding: 0 20px 0 10px;
  .item-head {
    text-align: left;
    // display: flex;
    // justify-content: space-between;
    .item-head-tittle {
      font-weight: 700;
      font-size: 16px;
      padding-bottom: 10px;
    }
  }
  .item-content {
    padding: 20px 0;
    .text-summary {
      text-align: left;
    }
    .chart-item {
      padding-bottom: 20px;
    }
  }
}
</style>
